module.exports = __webpack_public_path__ + "img/dox-half-loop.8b625533.gif";